// Settings -- route /settings
//
// Wraps the canonical SettingsPage from saas-common and registers project-
// specific custom panels. The kis_broker group is declared kind=custom in
// the server manifest; here we point it at KISBrokerPanel.

import { SettingsPage } from '@/admin-design/_common/settings'
import type { CustomRegistry } from '@/admin-design/_common/settings'
import KISBrokerPanel from '@/settings/custom/KISBrokerPanel'
import BithumbBrokerPanel from '@/settings/custom/BithumbBrokerPanel'

const customRegistry: CustomRegistry = {
  'kis-broker-panel': KISBrokerPanel,
  'bithumb-broker-panel': BithumbBrokerPanel,
}

export default function Settings() {
  return <SettingsPage customRegistry={customRegistry} />
}
